import { useQuery } from '@tanstack/react-query';
import { api } from './client';

export interface RoomStay {
  id: string;
  reference: string;
  guest: { id: string; name: string; phone: string | null };
  checkIn: string;
  checkOut: string;
  nights: number;
  adults: number;
  children: number;
  status: string;
  source: string;
  /** what the guest pays for the stay, tax included, in pesewas */
  total: number;
}

export interface RoomDetails {
  room: {
    id: string;
    number: string;
    floor: string | null;
    status: string;
    active: boolean;
    roomType: { id: string; name: string; description: string | null; maxAdults: number; maxChildren: number; active: boolean };
    rates: { code: string; name: string; baseRate: number; weekendRate: number | null; taxMode: 'INCLUSIVE' | 'EXCLUSIVE' }[];
  };
  today: string;
  current: RoomStay | null;
  upcoming: RoomStay[];
  recent: RoomStay[];
  lastDays: { days: number; stays: number; nights: number; revenue: number; occupancyPct: number };
  blocks: { id: string; from: string; to: string; reason: string }[];
  cleaning: { lastCleanedAt: string | null; tasks: { id: string; type: string; status: string; forDate: string; completedAt: string | null; inspectedAt: string | null }[] } | null;
  faults: { id: string; title: string; priority: string; status: string; createdAt: string; resolvedAt: string | null }[] | null;
  can: { bookings: boolean; cleaning: boolean; faults: boolean };
}

export const useRoomDetails = (id: string) => useQuery({ queryKey: ['rooms', 'details', id], enabled: !!id, queryFn: () => api<RoomDetails>(`/rooms/${id}/details`) });
